import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  TextField,
  Alert
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

const FixedWingWOCL = ({ baseline, handleChange }) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">Window of Circadian Low - WOCL (Note 1)</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Alert severity="info" sx={{ mb: 3 }}>
          <Typography variant="body2">
            WOCL reduction rules based on D7J-J4-Fixed Wing.pdf Note 1. FDP reduction when encroaching WOCL.
          </Typography>
        </Alert>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="WOCL Start Time"
              type="text"
              value={baseline.woclStartFixedWing}
              onChange={(e) => handleChange('woclStartFixedWing', e.target.value)}
              placeholder="02:00"
              helperText="WOCL start time (HH:mm format, default: 02:00)"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="WOCL End Time"
              type="text"
              value={baseline.woclEndFixedWing}
              onChange={(e) => handleChange('woclEndFixedWing', e.target.value)}
              placeholder="06:00"
              helperText="WOCL end time (HH:mm format, default: 06:00)"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Reduction (FDP Starts in WOCL)"
              type="number"
              value={baseline.woclReductionStartEncroachment}
              onChange={(e) => handleChange('woclReductionStartEncroachment', parseFloat(e.target.value))}
              inputProps={{ min: 0, max: 1, step: 0.1 }}
              helperText="Note 1: 100% reduction (1.0)"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Reduction (FDP Ends in WOCL)"
              type="number"
              value={baseline.woclReductionEndEncroachment}
              onChange={(e) => handleChange('woclReductionEndEncroachment', parseFloat(e.target.value))}
              inputProps={{ min: 0, max: 1, step: 0.1 }}
              helperText="Note 1: 50% reduction (0.5)"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max Reduction Hours"
              type="number"
              value={baseline.woclMaxReductionHours}
              onChange={(e) => handleChange('woclMaxReductionHours', parseFloat(e.target.value))}
              inputProps={{ min: 0, max: 3, step: 0.5 }}
              helperText="Note 1: Maximum 2 hours reduction"
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default FixedWingWOCL;
